app.controller('cadSyncController', async function ($rootScope, $scope, $filter, safeApply, cadSyncService) {

  let agent_id = null
  let uploadToGCS = null
  let downloadURL = ''

  const aoaTable = '#cad_sync_table'
  const host = "https://api.propertytax.io"
  const currentDate = new Date()
  const CurrentYear = currentDate.getFullYear()

  $scope.currentCounty = { name: 'Dallas', cad_code: '057', index: 0 }
  $scope.currentCountyOptions = null
  $scope.currentFiletype = null
  $scope.currentFileID = 0
  $scope.processing_data = false

  $scope.setCounty = function (county) {
    console.log('county :>> ', county);
    $scope.currentCounty = { name: county.county, cad_code: county.cad_code }
    $scope.currentCountyOptions = county.cad_options
    $scope.currentFiletype = null
    if (uploadToGCS) uploadToGCS.close()
    safeApply($scope)
  }

  // filename Schema:   yyyy_mm_dd_hh_mm
  // bucket: propertytax
  // folder: cad_sync/cad_code
  // filename: yyyy_mm_dd_hh_mm
  // path:  propertytax/cad_sync/cad_code/yyyy_mm_dd_hh_mm

  function setResetUppy() {
    if (uploadToGCS) uploadToGCS.close()
    const storageObj = {
      bucket: 'propertytax',
      path: `cad_sync/${$scope.currentCounty.cad_code}/${$scope.currentFiletype.name}`,
      filename: `${CurrentYear}_${currentDate.getMonth() + 1}_${currentDate.getDate()}_${currentDate.getHours()}_${currentDate.getMinutes()}`
    }
    downloadURL = `https://storage.googleapis.com/${storageObj.bucket}/${storageObj.path}/${storageObj.filename}.`
    console.log('storageObj :>> ', storageObj);
    initUppy(storageObj)
  }

  async function initUppy(storageObj) {
    let cad_code = storageObj
    let type = 'documents'
    let inline = true
    let acceptFiles = [
      'text/plain',
      'text/csv',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ]
    let maxNumberOfFiles = 1
    let target = '.UppyDragDrop'
    let prepend_to_file = ""
    let append_to_file = ""

    let file_type
    let bucket = storageObj.bucket  //'propertytax'
    let path = storageObj.path      //'county_portals/documents'
    let filename = storageObj.filename

    let orig_filename = ''

    uploadToGCS = new Uppy.Core({
      autoProceed: true,
      allowMultipleUploads: false,
      allowMultipleUploadBatches: false,
      restrictions: {
        allowedFileTypes: acceptFiles,
        maxNumberOfFiles: maxNumberOfFiles
      },
      onBeforeFileAdded: (currentFile, files) => {
        orig_filename = currentFile.name
        file_type = currentFile.extension
        console.log('currentFile :>> ', currentFile);
        console.log('file_type :>> ', file_type);
        downloadURL += file_type
      }
    }).use(Uppy.Dashboard, {
      inline: true,
      target: target || "body",
      fileManagerSelectionType: 'files',
      proudlyDisplayPoweredByUppy: false,
      showProgressDetails: true,
      hidePauseResumeButton: true,
      closeAfterFinish: false,
    }).use(Uppy.XHRUpload, {
      endpoint: host.concat('/gcs/upload/uploadToGCS'),
      method: 'post',
      fieldName: 'files',
      formData: true,
      bundle: false
    }).on('file-added', (file) => {   // use this to pass parameters to req.body as req.body.params
      let p = `{ "bucket": "${bucket}", "path": "${path}", "prepend": "${prepend_to_file}", "append": "${append_to_file}" }`
      try {
        file.meta.name = filename + '.' + file_type  //orig_filename
        file.meta.orig_filename = orig_filename
        $scope.processing_data = true
      } catch (error) {
        console.log('error :>> ', error)
        return false
      }
      uploadToGCS.setFileMeta(file.id, { 'params': p })
    }).on('upload-success', async (file, response) => {
      if (response.body.success) {
        const updateTableObj = {
          file_id: $scope.currentFiletype.file_id,
          uri: downloadURL
        }
        const updateUploadsTableResults = await cadSyncService.updateUploadsTable(updateTableObj)
        // console.log('updateUploadsTableResults :>> ', updateUploadsTableResults)
        $scope.processing_data = false

        if (updateUploadsTableResults.data.success) {
          $scope.cad_sync_results = updateUploadsTableResults.data.data
          var myModalEl = document.querySelector('#processingFiles')
          var modal = bootstrap.Modal.getOrCreateInstance(myModalEl) // Returns a Bootstrap modal instance
          modal.show()

        } else {
          console.log("Error uploading file!")
          alert("Error uploading file!")
        }
      } else {
        console.log("Error uploading file!")
        alert("Error uploading file!")
      }
      safeApply($scope)
    }).on('dashboard:modal-closed', () => {
      // If no file_type, then no file was selected
      if (file_type) {
        // console.log("***FILE UPLOAD COMPLETED ***");
        // console.log('file_type :>> ', file_type);
      }
    })
    uploadToGCS.getPlugin('Dashboard').openModal()
    window.uploadToGCS = uploadToGCS
  }

  $scope.setFileType = function (index) {
    $scope.currentFiletype = {
      index: index,
      name: $scope.currentCountyOptions[index].name,
      description: $scope.currentCountyOptions[index].description,
      file_id: $scope.currentCountyOptions[index].file_id
    }
    console.log('$scope.currentFiletype :>> ', $scope.currentFiletype);
    setResetUppy()
    safeApply($scope)
  }

  // Pulls in user info from the rootScope -> CRMController
  $rootScope.$watch('user_info', function () {
    $scope.user_info = $rootScope.user_info
    console.log('$scope.user_info :>> ', $scope.user_info);
  }, true)

  init()
  async function init() {
    let results = await cadSyncService.loadCadOptions()
    console.log('results :>> ', results);
    if (!results.data.success) {
      alert('Error loading CAD options')
      return
    }

    $scope.cadOptions = results.data.data
    console.log('****** $scope.cadOptions :>> ', $scope.cadOptions);

    safeApply($scope)
  }


})